import styled, {css} from 'styled-components'

export const StyledDropzoneRoot = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 2}px;
    `
)

export const StyledDropzoneArea = styled.div<{$active: boolean}>(
    ({theme: {palette, spacing, typography, transition}, $active}) => css`
        ${typography.textSm};
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: ${spacing}px;
        padding: ${spacing * 5}px ${spacing * 4}px;
        border: 1px dashed ${$active ? palette.primary[500] : palette.neutral[300]};
        border-radius: 8px;
        background: ${$active ? palette.primary[50] : palette.neutral[50]};
        color: ${palette.neutral[600]};
        text-align: center;
        cursor: pointer;
        transition: ${transition};

        &:hover {
            border-color: ${palette.primary[400]};
            background: ${palette.primary[50]};
        }

        &:focus-visible {
            outline: none;
            border-color: ${palette.primary[500]};
            box-shadow: 0 0 0 3px ${palette.primary[100]};
        }
    `
)

export const StyledDropzoneHint = styled.span(
    ({theme: {palette, typography}}) => css`
        ${typography.textXs};
        color: ${palette.neutral[400]};
    `
)

export const StyledFileList = styled.ul(
    ({theme: {spacing}}) => css`
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: ${spacing * 1.5}px;
    `
)

export const StyledFileRow = styled.li(
    ({theme: {palette, spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
        padding: ${spacing * 2}px ${spacing * 3}px;
        border: 1px solid ${palette.neutral[200]};
        border-radius: 8px;
        background: ${palette.neutral.white};
    `
)

export const StyledFileMain = styled.div(
    ({theme: {spacing}}) => css`
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: ${spacing * 0.5}px;
    `
)

export const StyledFileName = styled.span(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm};
        font-weight: 500;
        color: ${palette.neutral[800]};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    `
)

export const StyledFileError = styled.span(
    ({theme: {palette, typography}}) => css`
        ${typography.textXs};
        color: ${palette.danger[600]};
    `
)

export const StyledFileStatus = styled.span<{$variant: 'uploading' | 'done' | 'error'}>(
    ({theme: {palette}, $variant}) => css`
        display: inline-flex;
        align-items: center;
        color: ${$variant === 'done'
            ? palette.success[600]
            : $variant === 'error'
              ? palette.danger[500]
              : palette.neutral[400]};
    `
)

export const StyledRemoveButton = styled.button(
    ({theme: {palette, transition}}) => css`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        border: none;
        background: none;
        color: ${palette.neutral[400]};
        cursor: pointer;
        transition: ${transition};

        &:hover {
            color: ${palette.danger[500]};
        }

        &:focus-visible {
            outline: none;
            color: ${palette.danger[500]};
        }
    `
)
